module.exports = __webpack_public_path__ + "Frame402-1d1cce7f.webp";